import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import ProgessOutcomeView from './ProgessOutcomeView'
import ProgessOutcomeForm from './ProgessOutcomeForm'
import {
  getProgressOutcome,
  updateProgressOutcome,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
} from '../../redux/actions/projectProgress'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'
import { cloneDeep } from 'lodash-es'

export default function ProgessOutcomeWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('ProgessOutcomeWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
  }, [_schema])

  const handleCallService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateProgressOutcome(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgressOutcome(projectId, projectProgressId)
            console.log('getProgressOutcome', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    let valueList = []

    data.datalist.forEach((element) => {
      element.children.forEach((subElement) => {
        if (subElement.id.startsWith('ADD_ID_')) {
          subElement.id = ''
        }

        delete subElement._parent
        valueList.push(subElement)
      })
    })
    // ADD_ID_

    //set delete = true
    formSchema.values.forEach((element) => {
      element.children.forEach((master, index) => {
        let newItem = valueList.find((item) => item.id === master.id)
        if (newItem === undefined) {
          //master.projectProgressAcitivityId = element.id
          master.isDelete = true
          delete master._parent
          valueList.push(master)
        }
      })
    })

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      values: valueList,
    }
    console.log('request', JSON.stringify(request))

    handleCallService(request, progressId)
    // onChangeIsEdit(false)
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  const onClearAddNotSave = () => {
    console.log('onClearAddNotSave')

    var newFormSchema = cloneDeep(formSchema)
    let arr = [...newFormSchema.values]

    if (arr) {
      arr.forEach((element, labelIndex) => {
        element.children.forEach((subElement, childrenIndex) => {
          if (subElement.id.startsWith('ADD_ID_')) {
            arr[labelIndex].children.splice(childrenIndex, 1)
          }
        })
      })
      console.log('arr', arr)

      newFormSchema.values = arr

      setFormSchema(newFormSchema)
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.comment?.enableEdit ? (
        <>
          <ProgessOutcomeView schema={formSchema} />

          <hr />
          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

          {isEdit ? (
            <ProgessOutcomeForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              onSubmit={handleSubmit(onSubmit)}
              projectId={projectId}
              progressId={progressId}
              setFormSchema={setFormSchema}
            />
          ) : (
            <ProgessOutcomeView schema={formSchema} />
          )}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={
              formSchema?.comment?.enableEdit
                ? formSchema?.comment?.buttonText
                : formSchema.buttonText
            }
            onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              onClearAddNotSave()
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}

// const schema = {
//   header: 'ผลลัพธ์',
//   buttonText: 'ผลลัพธ์',
//   columnText1: 'ผลลัพธ์',
//   columnText2: 'ผลการดำเนินการ',
//   values: [
//     {
//       id: '1',
//       labelName:
//         'วัตถุประสงค์ข้อที่ 1 ส่งเสริมและสนับสนุนการสร้างเสริมสุขภาพในประชากรทุกวัยตามนโยบายสุขภาพแห่งชาติ',
//       result: '',
//       children: [
//         {
//           id: '1-1',
//           labelName:
//             'เกิดแผนงาน บทเรียนจากการทำงาน และความเข้าใจร่วมกันของชุมชน และยาวชนที่เข้าร่วมโครงการ',
//           result: '',
//           enableEdit: true,
//         },
//         {
//           id: '1-2',
//           labelName:
//             'ความสัมพันธ์ที่ดีกับกลุ่มเป้าหมาย นำไปสู่ความเข้าใจและให้การสนับสนุนในประเด็นเพื่อบรรลุเป้าหมาย',
//           result: 'ข้อความ YYY',
//           enableEdit: true,
//         },
//       ],
//     },
//     {
//       id: '2',
//       labelName:
//         'วัตถุประสงค์ข้อที่ 2  สร้างความตระหนักเรื่องพฤติกรรมเสี่ยงจากการบริโภคสุรา ยาสูบ หรือสาร หรือสิ่งอื่นที่ทำลายสุขภาพและสร้างความเชื่อในการสร้างเสริมสุขภาพแก่ประชากรทุกระดับ',
//       result: '',
//       children: [
//         {
//           id: '2-1',
//           labelName: 'เกิดบ้านต้นแบบสุภาพที่มีส่วนร่วมกับชุชน และยาวชน',
//           result: 'ข้อความ XXX',
//           enableEdit: true,
//         },
//         {
//           id: '2-2',
//           labelName: 'เยาวชนเรียนรู้ว่าสุขภาพที่ดีสามารถสร้างขึ้นด้วยการมีส่วนร่วม',
//           result: 'ข้อความ YYY',
//           enableEdit: true,
//         },
//       ],
//     },
//   ],
//   result: {
//     name: 'result',
//     hint: 'ผลการดำเนินการ',
//     validators: [
//       {
//         type: 'REQUIRED',
//         value: null,
//         errorMessage: 'กรุณากรอก ข้อมูล',
//       },
//     ],
//   },
// }
